import React from 'react';
import Modal from '../Modal';
import {useTranslation} from 'react-i18next';

/**
 * Confirmação de depósito / retirada no mesmo estilo do modal de excluir produto (borracharia_major).
 * @param {'deposit'|'retire'} variant
 */
export default function BankConfirmModal({
    isOpen,
    onClose,
    onConfirm,
    variant = 'deposit',
    message,
    loading = false,
}) {
    const { t } = useTranslation();
    const isDeposit = variant === 'deposit';

    const headerGradient = isDeposit
        ? 'linear-gradient(135deg, #2dca73 0%, #1fa855 100%)'
        : 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)';

    const iconClass = isDeposit ? 'fas fa-plus-circle' : 'fas fa-exclamation-triangle';
    const titleText = isDeposit ? t('bank_confirm_modal_deposit_title') : t('bank_confirm_modal_retire_title');

    const accentRgb = isDeposit ? '45, 202, 115' : '231, 76, 60';
    const softColor = isDeposit ? '#8aedab' : '#ff8888';

    const title = (
        <div
            style={{
                background: headerGradient,
                margin: 0,
                padding: '26px 24px 24px 24px',
                borderRadius: '14px 14px 0 0',
                borderBottom: '2px solid rgba(255, 255, 255, 0.1)',
            }}
        >
            <h2
                style={{
                    margin: 0,
                    color: '#ffffff',
                    fontSize: '22px',
                    fontWeight: 700,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                }}
            >
                <i className={iconClass} style={{ fontSize: '22px' }} aria-hidden="true"/>
                {titleText}
            </h2>
        </div>
    );

    const footer = (
        <>
            <button
                type="button"
                disabled={loading}
                onClick={onClose}
                style={{
                    background: 'rgba(255, 255, 255, 0.08)',
                    border: '1px solid rgba(255, 255, 255, 0.15)',
                    color: '#b0b0b0',
                    padding: '10px 24px',
                    borderRadius: '10px',
                    fontWeight: 600,
                    fontSize: '14px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s ease',
                    opacity: loading ? 0.6 : 1,
                }}
                onMouseEnter={(e) => {
                    if (!loading) {
                        e.target.style.background = 'rgba(255, 255, 255, 0.12)';
                        e.target.style.color = '#e0e0e0';
                    }
                }}
                onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(255, 255, 255, 0.08)';
                    e.target.style.color = '#b0b0b0';
                }}
            >
                {t('alert_cancel')}
            </button>
            <button
                type="button"
                disabled={loading}
                onClick={onConfirm}
                style={{
                    background: headerGradient,
                    border: 'none',
                    color: '#ffffff',
                    padding: '10px 24px',
                    borderRadius: '10px',
                    fontWeight: 600,
                    fontSize: '14px',
                    cursor: loading ? 'wait' : 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: `0 4px 15px rgba(${accentRgb}, 0.35)`,
                    opacity: loading ? 0.85 : 1,
                }}
                onMouseEnter={(e) => {
                    if (!loading) {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = `0 6px 20px rgba(${accentRgb}, 0.45)`;
                    }
                }}
                onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = `0 4px 15px rgba(${accentRgb}, 0.35)`;
                }}
            >
                {loading ? t('loading') : t('alert_confirm')}
            </button>
        </>
    );

    return (
        <Modal
            isOpen={isOpen}
            onClose={loading ? () => {} : onClose}
            title={title}
            footer={footer}
            narrow
        >
            <p
                style={{
                    margin: '0 0 20px 0',
                    color: '#b0b0b0',
                    fontSize: '15px',
                    lineHeight: 1.6,
                }}
            >
                {message}
            </p>
            <div
                style={{
                    background: `rgba(${accentRgb}, 0.14)`,
                    borderRadius: '10px',
                    padding: '16px',
                    border: `1px solid rgba(${accentRgb}, 0.35)`,
                }}
            >
                <p
                    style={{
                        margin: 0,
                        color: softColor,
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '10px',
                        fontWeight: 500,
                        lineHeight: 1.45,
                    }}
                >
                    <i className="fas fa-info-circle" style={{ marginTop: '2px' }} aria-hidden="true"/>
                    {t('bank_confirm_modal_notice')}
                </p>
            </div>
        </Modal>
    );
}
